<template>
	<div class="contentPage">
		<main-table
				v-if="driverStatementsFilterList"
				:text-create="getTexts.CREATE_STATEMENTS"
				:pageTitle='getTexts.DRIVER_STATEMENTS'
				:flag="flag"
				:settings="getSettings"
				:headers="headers"
				:listItems="driverStatementsList"
				:filtersList="driverStatementsFilterList"
				:uniqId="uniqId"
				:checkboxGroup="{ isCheckbox: true, isCheckboxAll: true }"
				:checkAll="checkAll"
				:indeterminate="indeterminate"
				@updateClickButton="onClickButton"
				@updateCreate="onCreate"
				@updateEdit="onEdit"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				@updateChangeSort="onFilter"
				@updateCheckOrder="onCheckOrder"
				@updateCheckOrders="onCheckOrders"
				@updateExport="onExport"
				@updateSettings="onSettingsOpen"
				@updateSend="onSend"
				@updatePaid="onPaid"
				text-send2="Send selected statements"
				isExport
				isSettings
				:is-send2="selected"
		></main-table>
		<create-statements
				v-if="isCreateStatements"
				@updateClose="onClose"
		></create-statements>
		<add-driver-statements
				v-if="isDriverStatements"
				:permissions="permissions"
				:itemId="itemId"
				@updateClose="onDriverStatementsClose"
		></add-driver-statements>
	  <table-settings
			  v-if="isTableSettingsDrawer"
			  @updateSettingsSave="onSettingsSave('drivers-statements')"
			  @updateSettingsCancel="onSettingsCancel"
			  @updateSettingsClose="onSettingsClose"
			  @updateSettingsAll="onSettingsAll"
			  :settings="getSettings"
	  ></table-settings>
		<send-driver-statements
				v-if="isSendDriverStatements"
				:selected="selected"
				@updateClose="onCloseSend"
				@updateLink="onLink"
		></send-driver-statements>
		<drawer-driver-statements
				v-if="isDrawerDriverStatements"
				:paidData="paidData"
				@updateClose="onDrawerDriverStatementsClose"
		></drawer-driver-statements>
		<remove-block v-if="isRemove" @updateRemoveItem="onRemoveItem" @updateRemoveClose="onRemoveClose"></remove-block>
		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"></preview-doc>
	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// async components
const CreateStatements = () => import("@/components/Accounting/DriverStatements/CreateStatements/CreateStatements");
const AddDriverStatements = () => import("@/components/Accounting/DriverStatements/AddDriverStatements/AddDriverStatements");
const SendDriverStatements = () => import("@/components/Accounting/DriverStatements/SendDriverStatements/SendDriverStatements");
const DrawerDriverStatements = () => import("@/components/Accounting/DriverStatements/DrawerDriverStatements/DrawerDriverStatements");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
const PreviewDoc = () => import("@/modules/invoices/preview");
// constants
import { DRIVER_STATEMENTS_TEXTS } from "@/pages/Accounting/DriverStatements/constants";
import { PERMISSIONS } from "@/constants/constants";
import { getAppUrl } from "@/services";
import settingsMixins from "@/mixins/settingsMixins";

export default {
	name: "DriverStatements",
	mixins: [ settingsMixins ],
	components: {
		CreateStatements,
		AddDriverStatements,
		RemoveBlock,
		SendDriverStatements,
		DrawerDriverStatements,
		PreviewDoc
	},
	computed: {
		...mapGetters([
			'customers',
			'driverStatementsList',
			'driverStatementsFilterList',
			'linksPermissions',
			'permissions'
		]),
		getTexts() {
			return DRIVER_STATEMENTS_TEXTS;
		},
	},
	data: () => ({
		refreshFilters: false,
		flag: "driverStatements",
		isFrozen: null,
		isRemove: false,
		loading: false,
		isCreateStatements: false,
		isDriverStatements: false,
		isSendDriverStatements: false,
		isDrawerDriverStatements: false,
		dataActions: null,
		editRow: null,
		uniqId: null,
		itemId: null,
		link: null,
		selected: [],
		indeterminate: false,
		checkAll: false,
	}),
	methods: {
		...mapActions([
			'getDriverStatementsList',
			'createSchedule',
			'onEditSchedule',
			'setWarning',
			'onDriverStatementsFilter',
			'onExportLink',
			'deleteDriverStatement'
		]),
		onCheckOrder(orderId) {
			const idx = this.selected.findIndex(({ id }) => id === orderId);
			if (idx === -1) {
				this.selected.push({ id: orderId });
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}

			if (this.selected.length && (this.selected.length !== this.driverStatementsList.length)) {
				this.indeterminate = true;
			}

			if (this.selected.length === this.driverStatementsList.length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.driverStatementsList.filter(item => item.status !== 'Open').map(body => ({ id: body.id }));
			} else {
				this.selected = [];
				this.indeterminate = false;
			}

			this.checkAll = value;
			this.driverStatementsList.forEach(item => item.isCheck = value);
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onDriverStatementsClose() {
			this.isDriverStatements = false;
		},
		onCloseSend() {
			this.isSendDriverStatements = false;
		},
		onLink(value) {
			this.link = `${ getAppUrl }/${ value }`;
		},
		clearLink() {
			this.link = null;
		},
		onSend() {
			this.isSendDriverStatements = true;
		},
		onPaid({ line }) {
			this.paidData = line;
			this.isDrawerDriverStatements = true;
		},
		onDrawerDriverStatementsClose() {
			this.isDrawerDriverStatements = false;
			this.paidData = null;
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'drivers-statements' });
		},
		async onFilter(info) {
			this.indeterminate = false;
			this.checkAll = false;
			this.selected = [];
			await this.onDriverStatementsFilter(info.filterModList);
		},
		getRemoveItem() {
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.deleteDriverStatement(this.itemId);
			this.isRemove = false;
		},
		onClickButton({ key, item }) {
			this.itemId = item.id;
			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}

			if (key === "edit") {
				if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
					this.isDriverStatements = true;
				}
			}
		},
		async onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
				this.itemId = line.id;
				this.isDriverStatements = true;
			}
		},
		async onCreate() {
			this.isCreateStatements = true;
		},
		onClose() {
			/*this.isDialog = false;
			this.dataActions = null;*/
			this.isCreateStatements = false;
		},
		async onSafe() {
			// this.loading = true;

		},
	},
	async mounted() {
		await this.getDriverStatementsList();
	}
};
</script>

